import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Accordion from '~/components/Accordion';
import { kebabCase, isString } from 'lodash';

const AccordionsWrapper = styled.div`
    border: ${({ colorTheme }) => (colorTheme === 'thin' ? '1px' : '4px')} solid
        ${({ theme, accentColor }) =>
            accentColor === 'white'
                ? theme.colors.primary.white
                : theme.colors.text.lightBlue};
    ${({ colorTheme, theme }) =>
        colorTheme === 'thin' && `border-color: ${theme.colors.text.black};`};

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        border-width: ${({ colorTheme }) =>
            colorTheme === 'thin' ? '1px' : '5px'};
    }
`;

const AccordionGroup = ({
    accordions,
    className = '',
    accentColor = 'lightBlue',
    colorTheme = 'light'
}) => {
    const [openSections, setOpenSections] = useState({});

    const handleClick = (id) => {
        setOpenSections((openSections) => {
            const isOpen = openSections[id];
            return {
                [id]: !isOpen
            };
        });
    };

    return (
        <AccordionsWrapper {...{ accentColor, colorTheme, className }}>
            {accordions.map(({ preTitle, title, content }) => {
                const id = kebabCase(title);
                const isOpen = !!openSections[id];
                return isString(content) ? (
                    <Accordion
                        key={id}
                        {...{
                            preTitle,
                            title,
                            content,
                            id,
                            isOpen,
                            handleClick,
                            accentColor,
                            colorTheme
                        }}
                    />
                ) : (
                    <Accordion
                        key={id}
                        {...{
                            preTitle,
                            title,
                            id,
                            isOpen,
                            handleClick,
                            accentColor,
                            colorTheme
                        }}
                    >
                        {content}
                    </Accordion>
                );
            })}
        </AccordionsWrapper>
    );
};

AccordionGroup.propTypes = {
    accordions: PropTypes.arrayOf(
        PropTypes.shape({
            preTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            title: PropTypes.string.isRequired,
            content: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
                .isRequired
        })
    ).isRequired,
    accentColor: PropTypes.oneOf(['lightBlue', 'white']),
    colorTheme: PropTypes.oneOf(['light', 'dark', 'thin']),
    className: PropTypes.string
};

export default AccordionGroup;
